module.exports = __webpack_public_path__ + "img/img-cate4.6c0c2437.webp";